import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEPlasticCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Plastic Engineering",
    shortName: "B.E. Plastic",
    duration: "4 years",
    description: "Specialized engineering program focused on polymer science, plastic processing, and materials technology",
    overview: "Bachelor of Engineering in Plastic Engineering (B.E. Plastic) is a 4-year undergraduate program that deals with the design, processing, and application of plastic materials. This course covers polymer science, injection molding, extrusion, thermoforming, and advanced plastic technologies, preparing students for careers in the rapidly growing plastics and polymer industry.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in materials science and chemistry"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Polymer Science",
          "Materials Science"
        ]
      },
      {
        year: 2,
        subjects: [
          "Organic Chemistry",
          "Polymer Chemistry",
          "Thermodynamics",
          "Fluid Mechanics",
          "Plastic Materials",
          "Engineering Mechanics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Plastic Processing Technology",
          "Injection Molding",
          "Extrusion Technology",
          "Blow Molding",
          "Quality Control in Plastics",
          "Mold Design"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Plastic Processing",
          "Plastic Product Design",
          "Recycling and Sustainability",
          "Plastic Testing and Analysis",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Plastic Engineer",
        "Process Engineer",
        "Product Design Engineer",
        "Quality Control Engineer",
        "R&D Engineer",
        "Mold Design Engineer",
        "Production Manager",
        "Technical Sales Engineer",
        "Application Engineer",
        "Materials Engineer"
      ],
      industries: [
        "Plastic Manufacturing",
        "Automotive Industry",
        "Packaging Industry",
        "Electronics Manufacturing",
        "Medical Device Manufacturing",
        "Toys and Consumer Goods",
        "Construction Materials",
        "Aerospace Industry",
        "Research and Development",
        "Recycling Companies"
      ],
      averageSalary: "₹4-9 LPA (Fresher), ₹15-35 LPA (Experienced)",
      topRecruiters: [
        "Reliance Industries, ONGC Petro",
        "Bajaj Auto, Maruti Suzuki",
        "Tupperware, Milton",
        "Supreme Industries, Astral Pipes",
        "Motherson Sumi, Varroc",
        "Huhtamaki, Uflex"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Central Institute of Plastics Engineering & Technology",
        location: "Chennai",
        fees: "₹2,50,000",
        ranking: "Premier Plastics Institute"
      },
      {
        name: "Harcourt Butler Technical University",
        location: "Kanpur",
        fees: "₹3,00,000",
        ranking: "State Technical University"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      },
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      }
    ],

    skills: [
      "Polymer Processing",
      "Mold Design and CAD",
      "Quality Control Systems",
      "Injection Molding Operations",
      "Material Selection",
      "Process Optimization",
      "Product Design",
      "Testing and Analysis",
      "Sustainability Practices",
      "Project Management"
    ],

    futureScope: "Growing prospects with expanding plastic applications, sustainable packaging solutions, electric vehicle components, and advanced polymer technologies in aerospace and medical sectors.",

    faqs: [
      {
        question: "What career opportunities exist in Plastic Engineering?",
        answer: "Opportunities include automotive components, packaging industry, medical devices, consumer goods, aerospace applications, and emerging sustainable plastics development."
      },
      {
        question: "Is there focus on sustainable plastics?",
        answer: "Yes, the field increasingly emphasizes biodegradable plastics, recycling technologies, and sustainable manufacturing processes to address environmental concerns."
      },
      {
        question: "Can I work in the automotive industry?",
        answer: "Yes, automotive industry extensively uses plastic engineers for designing lightweight components, interior parts, and advanced polymer solutions for electric vehicles."
      },
      {
        question: "What about research opportunities?",
        answer: "Excellent research opportunities in advanced polymers, nanotechnology, biodegradable materials, and smart plastics in both industry and academic institutions."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEPlasticCoursePage;
